// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__zH4bS","loader-container":"Loader_loader-container__OOCDQ","spin89345":"Loader_spin89345__XRONb"};